import * as React from "react";
import styled from "styled-components";

import { colors } from "../../common/utils/style";
import Translate from "../../common/components/Translate";
import CompanyValuesPickerItem, { CompanyValuesPickerItemModels } from "./CompanyValuesPickerItem";

type CompanyValueFeature = CompanyValuesPickerItemModels["CompanyValueFeature"];

interface CategorizedCompanyValueFeature {
  category: string;
  features: CompanyValueFeature[];
}

export interface CompanyValuesPickerModels {
  CompanyValueFeature: CompanyValueFeature;
  CategorizedCompanyValueFeature: CategorizedCompanyValueFeature;
}

interface Props {
  selectedFeatures: string[];
  features: CategorizedCompanyValueFeature[];
  onChange(features: string[]): void;
}

interface State {
  selectedCategory?: string;
}

class CompanyValuesPicker extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  public onSelect = (feature: CompanyValueFeature) => {
    const { selectedFeatures, onChange } = this.props;

    if (selectedFeatures.length < 6) {
      onChange(selectedFeatures.concat(feature.feature));
    }
  };

  public onUnselect = (feature: CompanyValueFeature) => {
    const { selectedFeatures, onChange } = this.props;
    onChange(selectedFeatures.filter(v => v !== feature.feature));
  };

  public render() {
    const { features, selectedFeatures } = this.props;
    const { selectedCategory } = this.state;
    return (
      <Wrapper>
        <FilterWrapper>
          <FilterItem
            selected={!selectedCategory}
            onClick={() => {
              this.setState({ selectedCategory: undefined });
            }}
          >
            <Translate id="company_values.feature_categories.all_values" />
          </FilterItem>
          {features.map(({ category }) => {
            return (
              <FilterItem
                key={category}
                selected={selectedCategory === category}
                onClick={() => {
                  this.setState({ selectedCategory: category });
                }}
              >
                <Translate id={`company_values.feature_categories.${category}`} />
              </FilterItem>
            );
          })}
        </FilterWrapper>
        <FeaturesWrapper>
          {features.map(({ category, features }) => {
            if (selectedCategory && selectedCategory !== category) {
              return null;
            }
            return (
              <FeaturesList key={category}>
                {!selectedCategory && (
                  <CategoryLabel>
                    <Translate id={`company_values.feature_categories.${category}`} />
                  </CategoryLabel>
                )}
                <div>
                  {features.map(f => {
                    const selectedIndex = selectedFeatures.indexOf(f.feature);
                    return (
                      <CompanyValuesPickerItem
                        key={f.feature}
                        feature={f}
                        selectedIndex={selectedIndex >= 0 ? selectedIndex + 1 : undefined}
                        onSelect={this.onSelect}
                        onUnselect={this.onUnselect}
                      />
                    );
                  })}
                </div>
              </FeaturesList>
            );
          })}
        </FeaturesWrapper>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  position: relative;
  width: 650px;
  height: 515px;
  background-color: rgba(250, 250, 250, 1);
`;

const FilterWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  padding: 20px 20px 15px;
  box-sizing: border-box;
  background-color: rgba(250, 250, 250, 1);
  border-bottom: 1px solid ${colors.layoutLightBorder};
  display: flex;
`;

const FilterItem = styled.button`
  height: auto;
  margin-right: 1px;
  padding: 6px 10px;
  border: none;
  border-radius: 15px;
  font-weight: 600;
  font-size: 12px;
  line-height: 1;
  color: rgba(0, 0, 0, 0.8);
  outline: none;
  background-color: ${(p: { selected: boolean }) => (p.selected ? "rgba(238, 238, 238, 1)" : "transparent")};
  &:hover {
    background-color: rgba(238, 238, 238, 1);
  }
`;

const FeaturesWrapper = styled.div`
  height: calc(100% - 65px);
  margin-top: 65px;
  padding: 15px 0 20px;
  box-sizing: border-box;
  overflow: auto;
`;

const FeaturesList = styled.div`
  margin-bottom: 40px;
  &:last-child {
    margin-bottom: 0;
  }
`;

const CategoryLabel = styled.div`
  margin-bottom: 20px;
  padding: 0 20px;
  font-weight: 600;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.8);
`;

export default CompanyValuesPicker;



// WEBPACK FOOTER //
// ./frontend/src/company_values/components/CompanyValuesPicker.tsx